import util from '@bmp-vue/core/api/util'

const controller = 'Parametro'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetByIdentificador: function (identificador) {
    return util.Axios.Get(controller + '/GetByIdentificador', identificador)
  },
  TipoOperacaoCred: [
    { value: 1, text: 'Com Garantia' },
    { value: 2, text: 'Sem Garantia' },
    { value: 3, text: 'Financiamento/Refinanciamento' }
  ],
  TipoPessoa: [
    { value: 'PF', text: 'Pessoa Física' },
    { value: 'PJ', text: 'Pessoa Jurídica' }
  ]
})
